import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useCancelPayout } from '@bcraft-frontend-lib/payments'
import block from 'bem-cn'

import { selectLocaleDict } from 'features/locale/selectors'

import Button from 'components/UIKit/Button/Button'

import './WithdrawCancel.scss'

const b = block('withdraw-cancel')

const WithdrawCancel: React.FC<{}> = () => {
  const { common } = useSelector(selectLocaleDict, shallowEqual)

  const { cancelPayoutCommunication, textArray, onClose, handleSubmit } = useCancelPayout({})

  return (
    <div className={b()}>
      <div className={b('container')}>
        <form className={b('form')} onSubmit={handleSubmit}>
          <section className={b('section')}>
            <p className={b('text')}>{textArray[0]}</p>
            <p className={b('text', { notice: true })}>{textArray[1]}</p>
            <div className={b('buttons')}>
              <div className={b('button-wrapper')}>
                <Button
                  type="submit"
                  text={common.yes}
                  disabled={cancelPayoutCommunication?.isLoading}
                  loading={cancelPayoutCommunication?.isLoading}
                />
              </div>
              <div className={b('button-wrapper')}>
                <Button onClick={onClose} text={common.no} />
              </div>
            </div>
          </section>
        </form>
      </div>
    </div>
  )
}

export { WithdrawCancel }
